import React from 'react';
import Container from '../../../components/surfaces/container';
import styles from './style';
import FormControl from '../../../components/inputs/form-control';
import COLORS from '../../../constants/colors';
import PasswordInput from '../components/inputs/password-input/index.web';
import { useTranslation } from 'react-i18next';
import { tKeys } from '../../../translations/keys';
import useLogic from './logic.web';
import { VStack, Text, Button, Stack, Link, Box } from '@chakra-ui/react';
import FONTS from '../../../constants/fonts';
import { PageWebAuth } from '../../../components/surfaces/page-auth/index.web';
import Input from '../../../components/inputs/input/index.web';
const SignInPage = () => {
    // Attributes
    const { t } = useTranslation();
    const { form, handleOnPressForgotPassword, handlerOnSubmit, isSubmitButtonDisabled, isAuthenticatePersonLoading, continueButtonRef, handleKeyPress, authError, healthCheckError, } = useLogic();
    const ContinueButton = (<VStack w="full" pt="2.5rem">
      <Button ref={continueButtonRef} 
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    onClick={handlerOnSubmit} isDisabled={isSubmitButtonDisabled} isLoading={isAuthenticatePersonLoading} width="full" textColor={COLORS.White.T500.value} fontSize={16} fontWeight={600} height="3rem" bgColor={COLORS.Govrn.Blue.T500.value} _hover={{ bgColor: COLORS.Govrn.Blue.T600.value }} _active={{ bgColor: COLORS.Govrn.Blue.T700.value }} transition="all 0.2s ease-in-out">
        {t(tKeys.common.continue)}
      </Button>
    </VStack>);
    // Render
    return (<PageWebAuth>
      <Stack width={'full'} maxWidth={'480px'} mx={'auto'} px={'2.5rem'} pb={'2.5rem'} pt={'2rem'} spacing={'1.5rem'}>
        {/*  Page title */}
        <Text color={COLORS.Text.T400.value} fontWeight={700} fontSize={28} alignSelf="start" mb="1rem">
          {t(tKeys?.['sign-in'].page.title)}
        </Text>

        {/* Health check error message */}
        {healthCheckError && (<Box p="0.75rem" bg={COLORS.Error.T100.value} borderRadius="0.375rem" mb="0.5rem">
            <Text color={COLORS.Error.T500.value} fontSize={14}>
              We're having trouble connecting to our services. This could be due
              to a network issue or a firewall blocking the connection. Please
              check your internet connection and firewall settings.
            </Text>
            <Text color={COLORS.Error.T500.value} fontSize={14} mt={2}>
              If the problem persists, please refer to our{' '}
              <Link color={COLORS.Govrn.Blue.T500.value} href="https://govrn.com/guides/domains-protocols" isExternal textDecoration="underline">
                documentation
              </Link>{' '}
              or contact support at support@govrn.com
            </Text>
          </Box>)}

        {/* Affichage des erreurs d'authentification */}
        {authError && (<Text color={COLORS.Error.T500.value} fontSize={14} p="0.75rem" bg={COLORS.Error.T100.value} borderRadius="0.375rem" mb="0.5rem">
            {authError}
          </Text>)}

        {/* Identity input */}
        <Container style={{
            ...styles.phoneInputContainer,
        }}>
          <FormControl label={t(tKeys['sign-in'].page['identity-input'].label) || ''} error={form?.email?.meta?.error} spacing={2}>
            <Input type="email" value={form?.email?.value} onChange={e => form?.email?.onChange?.(e?.currentTarget?.value)} placeholder={t(tKeys['sign-in'].page['identity-input'].placeholder) || ''} aria-label={t(tKeys['sign-in'].page['identity-input'].label) || ''} autoFocus _focus={{
            borderColor: COLORS.Govrn.Blue.T500.value,
            boxShadow: `0 0 0 1px ${COLORS.Govrn.Blue.T500.value}`,
        }}/>
          </FormControl>
        </Container>

        {/*  Password input */}
        <Container style={{
            ...styles.phoneInputContainer,
        }} testID={'signInPasswordInput'}>
          <FormControl label={t(tKeys.common.password.label) || ''} error={form?.password?.meta?.error} spacing={2} endHelperEnhancer={<Stack onClick={handleOnPressForgotPassword} cursor={'pointer'}>
                <Text color={COLORS.Govrn.Blue.T500.value} fontFamily={FONTS.T1.T12Px.Regular400.value.fontFamily} fontSize={FONTS.T1.T12Px.Regular400.value.fontSize} fontWeight={FONTS.T1.T12Px.Regular400.value.fontWeight} _hover={{ textDecoration: 'underline' }} transition="all 0.2s">
                  {t(tKeys['sign-in'].page['password-input'].forgot)}
                </Text>
              </Stack>}>
            <PasswordInput {...form?.password} style={{
            paddingVertical: 12,
            borderRadius: '.5rem',
        }} placeholder={t(tKeys['sign-in'].page['password-input'].placeholder) || ''} hasAutoComplete onKeyDown={handleKeyPress} aria-label={t(tKeys.common.password.label) || ''} _focus={{
            borderColor: COLORS.Govrn.Blue.T500.value,
            boxShadow: `0 0 0 1px ${COLORS.Govrn.Blue.T500.value}`,
        }}/>
          </FormControl>
        </Container>

        {ContinueButton}

        {/* Lien vers la page d'inscription */}
        <Text textAlign="center" fontSize="14px" pt="1rem">
          {t(tKeys.common.noAccount) || "Don't have an account?"}{' '}
          <Text as="span" color={COLORS.Govrn.Blue.T500.value} fontWeight="500" cursor="pointer" _hover={{ textDecoration: 'underline' }}>
            {t(tKeys.common.signUp) || 'Sign up'}
          </Text>
        </Text>
      </Stack>
    </PageWebAuth>);
};
export default SignInPage;
